import { filter } from 'lodash'

const checkBetaUser = (userRoles) => {
	if (userRoles) {
		return filter(userRoles, (o) => {
			return o.roleId.includes('BETABETA')
		})
	}
	return ['ADMIN']
}

export { checkBetaUser }



// WEBPACK FOOTER //
// ./src/utils/UserUtils.js